
export type CompressionLevel =
    "Optimal"
    | "Fastest"
    | "NoCompression";